/**
 * @generated SignedSource<<80b0b59978e9a29aaa755170e804b1d8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FileUploadRequestStatus = "CANCELED" | "CLOSED" | "PENDING" | "UPLOADED";
export type FileUploadRequestType = "AFFECTED_AREA_NOT_VISIBLE" | "DOCUMENT_REQUIRED" | "INSUFFICIENT_QUALITY_OF_PHOTOS" | "PHOTOS_REQUIRED";
import { FragmentRefs } from "relay-runtime";
export type FileUploadRequestFragment$data = {
  readonly createdAt: string;
  readonly createdBy: string;
  readonly id: string;
  readonly sessionCode: string;
  readonly status: FileUploadRequestStatus;
  readonly type: FileUploadRequestType;
  readonly " $fragmentType": "FileUploadRequestFragment";
};
export type FileUploadRequestFragment$key = {
  readonly " $data"?: FileUploadRequestFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FileUploadRequestFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FileUploadRequestFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sessionCode",
      "storageKey": null
    }
  ],
  "type": "FileUploadRequest",
  "abstractKey": null
};

(node as any).hash = "0fbfad79de31e1a14ee3f2137a4a3dbb";

export default node;
